


















import {Component, Prop, Vue} from 'vue-property-decorator';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';
import Dialog from '@/components/Dialog.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {ConfirmButton, CancelButton, Dialog},
})
export default class AddManufacturer extends Vue {
  @Prop() private isManufacturerDialogVisible!: boolean;
  private manufacturer: any = {
    name: '',
  };

  private async save() {
    await AdminDeviceTypeService.addManufacturer(this.manufacturer);
    this.$emit('close');
  }

}
